import Image from 'next/image';

export default function IconBar() {
  const items = [
    { icon: '/icons/white/search.svg', label: 'Research Windows Brands' },
    { icon: '/icons/white/money.svg', label: 'Compare Price Quotes' },
    { icon: '/icons/white/home.svg', label: 'View Installation Options' },
    { icon: '/icons/white/calendar.svg', label: 'Schedule Consultation' },
  ];

  return (
    <div className="mt-8">
      <div className="bg-emerald-600/80 backdrop-blur-sm rounded-xl p-2 shadow-lg">
        {/* Enable scroll only on mobile */}
        <div className="overflow-x-auto md:overflow-visible">
          <div className="flex gap-3 md:gap-6 w-max md:w-full md:justify-between px-2 md:px-0">
            {items.map(({ icon, label }, i) => (
              <div
                key={i}
                className="flex flex-col items-center p-3 min-w-[120px] md:min-w-0 flex-shrink-0 md:flex-shrink hover:bg-emerald-600/70 rounded-lg transition-colors cursor-pointer"
              >
                <Image
                  src={icon}
                  alt={label}
                  width={40}
                  height={40}
                  className="mb-2"
                />
                <span className="text-xs font-medium text-white text-center">
                  {label}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
